import {getCookie} from "cookies-next";
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const API_BASE_URL = 'https://dhlee.taydocantho.com/api';
//const API_BASE_URL = 'https://api-daotao.truonglaitaydo.com/api';
// console.log(process.env.REACT_APP_API_BASE_URL);

async function fetchApi<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${API_BASE_URL}${endpoint}`;
    const token = getCookie('auth-token');

    const defaultHeaders: HeadersInit = {};

    if (!(options.body instanceof FormData)) {
        defaultHeaders['Content-Type'] = 'application/json';
    }
    if (token) {
        defaultHeaders['Authorization'] = `${token}`;
    }

    const response = await fetch(url, {
        ...options,
        headers: {
            ...defaultHeaders,
            ...options.headers
        }
    });

    if (!response.ok) {
        var responseException = await response.json();
        if (responseException.responseException && responseException.responseException.exceptionMessage) {
            throw new Error(`${responseException.responseException.exceptionMessage}`);
        }
        throw new Error(`${response.status}: ${response.statusText}`);
    }

    return await response.json();
}

export default fetchApi;